export default __webpack_public_path__ + "static/media/slider1.054aa2fb.jpg";